module.exports = __webpack_public_path__ + "media/country_flags/bm-48eb3d36.png";